import { Observable } from 'rxjs';
import { fromFetch } from 'rxjs/fetch';
import { switchMap, catchError } from 'rxjs/operators';
import { GlobalEnvironment, getParams, postParams, putParams } from 'Helpers';
import { HubsLogbook } from "Models";
import { StatusCodeService } from 'Services';
import { msalTemp } from 'Contexts/AuthProvider';

export class HubsLogbookService {

    static GetById(id: number): Observable<HubsLogbook> {
        const accessToken = msalTemp.getActiveAccount()?.idToken
        const params = { ...getParams, headers: { Authorization: `Bearer ${accessToken}`, "Content-Type": "application/json" } };

        const data$ = fromFetch(`${GlobalEnvironment.GetUrl_API()}api/HubsLogbook/${id}`, params).pipe(
            switchMap(response => {
                if (response.ok) {
                    return Promise.resolve(response.json());
                } else {
                    return Promise.reject(StatusCodeService.GetMessage(response.status, "HubsLogbookService.GetById"));
                }
            }),
            catchError(err => Promise.reject(err))
        );

        return data$;
    }
    
    static GetAll(): Observable<HubsLogbook[]> {
        const accessToken = msalTemp.getActiveAccount()?.idToken
        const params = { ...getParams, headers: { Authorization: `Bearer ${accessToken}`, "Content-Type": "application/json" } };

        const data$ = fromFetch(`${GlobalEnvironment.GetUrl_API()}api/HubsLogbook`, params).pipe(
            switchMap(response => {
                if (response.ok) {
                    return Promise.resolve(response.json());
                } else {
                    return Promise.reject(StatusCodeService.GetMessage(response.status, "HubsLogbookService.GetAll"));
                }
            }),
            catchError(err => Promise.reject(err))
        );

        return data$;
    }

    static GetAllByStatusName(status: string): Observable<HubsLogbook[]> {
        const accessToken = msalTemp.getActiveAccount()?.idToken
        const params = { ...getParams, headers: { Authorization: `Bearer ${accessToken}`, "Content-Type": "application/json" } };

        const data$ = fromFetch(`${GlobalEnvironment.GetUrl_API()}api/HubsLogbook/GetAllByStatusName/${status}`, params).pipe(
            switchMap(response => {
                if (response.ok) {
                    return Promise.resolve(response.json());
                } else {
                    return Promise.reject(StatusCodeService.GetMessage(response.status, "HubsLogbookService.GetAllByStatusName"));
                }
            }),
            catchError(err => Promise.reject(err))
        );

        return data$;
    }

    static GetAllUniqueStatuses(): Observable<string[]> {
        const accessToken = msalTemp.getActiveAccount()?.idToken
        const params = { ...getParams, headers: { Authorization: `Bearer ${accessToken}`, "Content-Type": "application/json" } };

        const data$ = fromFetch(`${GlobalEnvironment.GetUrl_API()}api/HubsLogbook/GetAllUniqueStatuses`, params).pipe(
            switchMap(response => {
                if (response.ok) {
                    return Promise.resolve(response.json());
                } else {
                    return Promise.reject(StatusCodeService.GetMessage(response.status, "HubsLogbookService.GetAllUniqueStatuses"));
                }
            }),
            catchError(err => Promise.reject(err))
        );

        return data$;
    }

    static InsertHubsLogbook(HubsLogbook: HubsLogbook): Observable<HubsLogbook> {
        const accessToken = msalTemp.getActiveAccount()?.idToken
        const params = { ...postParams(JSON.stringify(HubsLogbook)), headers: { Authorization: `Bearer ${accessToken}`, "Content-Type": "application/json" } };

        const data$ = fromFetch(`${GlobalEnvironment.GetUrl_API()}api/HubsLogbook`, params).pipe(
            switchMap(response => {
                if (response.ok) {
                    return Promise.resolve(response.json());
                } else {
                    return Promise.reject(StatusCodeService.GetMessage(response.status, "HubsLogbookService.InsertHubsLogbook"));
                }
            }),
            catchError(err => Promise.reject(err))
        );

        return data$;
    }

    static EditHubsLogbook(HubsLogbook: HubsLogbook): Observable<HubsLogbook> {
        const accessToken = msalTemp.getActiveAccount()?.idToken
        const params = { ...putParams(JSON.stringify(HubsLogbook)), headers: { Authorization: `Bearer ${accessToken}`, "Content-Type": "application/json" } };

        const data$ = fromFetch(`${GlobalEnvironment.GetUrl_API()}api/HubsLogbook`, params).pipe(
            switchMap(response => {
                if (response.ok) {
                    return Promise.resolve(response.json());
                } else {
                    return Promise.reject(StatusCodeService.GetMessage(response.status, "HubsLogbookService.EditHubsLogbook"));
                }
            }),
            catchError(err => Promise.reject(err))
        );

        return data$;
    }
}